// extracted by mini-css-extract-plugin
module.exports = {"product-actions":"action-section_product-actions__1oRwC","disclaimers":"action-section_disclaimers__BSuYG","customizationStatus":"action-section_customizationStatus__JE2Op"};